// extracted by mini-css-extract-plugin
export var activeFilterButton = "_jc-c";
export var backButton = "_jc-4";
export var backIcon = "_jc-5";
export var chevronShortcut = "_jc-6";
export var container = "_jc-1";
export var editor = "_jc-8";
export var editorWrapper = "_jc-7";
export var prefix = "_jc-2";
export var searchIcon = "_jc-3";
export var suffix = "_jc-9";
export var suffixContent = "_jc-a";
export var suffixText = "_jc-b";
export var wrapper = "_jc-0";